module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [(_vm.originServiceCode) ? _c('quote-accessorial-item', {
    attrs: {
      "reporting-currency": _vm.reportingCurrency,
      "job-currency": _vm.jobCurrency,
      "quote-currency": _vm.quoteCurrency,
      "rate": _vm.rate,
      "rate-request": _vm.rateRequest,
      "type": "Origin",
      "job-accessorials": _vm.originJobAccessorials,
      "service-code": _vm.originServiceCode
    },
    on: {
      "add-accessorial": _vm.addOriginJobAccesorial
    }
  }) : _vm._e(), _vm._v(" "), (_vm.destinationServiceCode) ? _c('quote-accessorial-item', {
    attrs: {
      "reporting-currency": _vm.reportingCurrency,
      "job-currency": _vm.jobCurrency,
      "quote-currency": _vm.quoteCurrency,
      "rate": _vm.rate,
      "rate-request": _vm.rateRequest,
      "type": "Destination",
      "job-accessorials": _vm.destinationJobAccessorials,
      "service-code": _vm.destinationServiceCode
    },
    on: {
      "add-accessorial": _vm.addDestinationJobAccesorial
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02a4b6be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteAccessorials.vue
// module id = 2069
// module chunks = 1